import React from "react";

import CTA from "../../common/CTA";
import styles from "../EmptyBasket/EmptyBasket.module.scss";

export default function EmptyBasket() {
  return (
    <>
      <div className="row">
        <div
          className={`grid-md-9 grid-xs-3 ${styles["empty-basket-container"]}`}
        >
          <h6 className={`text-md`}>Your bag is empty</h6>
          <CTA text="Continue shopping" link="/" sizeClass={"normal-md normal-sm normal-xs"}/>
        </div>
      </div>
    </>
  );
}
